(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lucky-leaf-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucky-leaf-addon')) {
    customElements.define('lucky-leaf-addon', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.querySelector('form').addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = this.querySelector('button');
          if (button.disabled) return;
          const status = this.querySelector('[role="status"]');
          const drawer = document.querySelector('cart-drawer');
          const form = event.currentTarget;
          const data = new FormData(form);
          if (drawer) {
            data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
            data.append('sections_url', window.location.pathname);
            drawer.setActiveElement(button);
          }
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          status.hidden = true;
          try {
            const response = await fetch(form.action + '.js', {
              method:'POST', headers:{'X-Requested-With':'XMLHttpRequest'}, body:data
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
            status.textContent = this.dataset.success;
            status.hidden = false;
            if (!drawer) { window.location.assign(window.routes.cart_url); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
            publish(PUB_SUB_EVENTS.cartUpdate, {source:'lucky-leaf-addon', cartData:result});
          } catch (error) {
            status.textContent = error instanceof TypeError ? this.dataset.error : error.message;
            status.hidden = false;
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
